<div
  class="basket-item"
  [ngClass]="{ banner, showError: errorText.length > 0 }"
  [id]="id"
>
  <span class="tag" *ngIf="banner">{{ banner | i18next }}</span>
  <ng-container *ngIf="errorText.length > 0">
    <img
      [src]="this.imageUrlService.getImageUrl('/assets/images/error.svg')"
      alt="error sign"
    />
    <h2>{{ 'technical_difficulties_text' | i18next }}</h2>
    <p>{{ errorText | i18next }}</p>
  </ng-container>

  <ng-container *ngIf="!errorText.length">
    <div class="content basket-item__container">
      <div class="description">
        <div class="top">
          <span class="number">{{ currentCount }} X</span>
          <p class="type">
            <i class="fa fa-ticket" aria-hidden="true"></i>
            {{ title }}
            <button
              type="button"
              class="info"
              (click)="handleInfoClicked()"
              aria-label="info button"
            >
              <i class="fa fa-info" aria-hidden="true"></i>
            </button>
          </p>
        </div>
        <p class="desc">{{ translatedSubtitle }}</p>

        <div class="price-quality-controls">
          <p class="price">{{ price | currency }}</p>

          <div class="price-quality-controls__mobile">
            <nx-ng-basket-item-quantity [count]="currentCount" (quantityUpdated)="handleQuantityUpdated($event)"></nx-ng-basket-item-quantity>

            <nx-ng-buy-single-button
              [id]="buyButtonId"
              [count]="currentCount"
              [separateRemoveLink]="false"
              [canOnlyRemove]="true"
              (quantityUpdated)="handleQuantityUpdated($event)"
            >
            </nx-ng-buy-single-button>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="quantity-controls">
          <nx-ng-basket-item-quantity [count]="currentCount" (quantityUpdated)="handleQuantityUpdated($event)"></nx-ng-basket-item-quantity>

          <nx-ng-buy-single-button
            [id]="buyButtonId"
            [count]="currentCount"
            [separateRemoveLink]="false"
            [canOnlyRemove]="true"
            (quantityUpdated)="handleQuantityUpdated($event)"
          >
          </nx-ng-buy-single-button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
